import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from "./firebase";

const log = () => logEvent(getAnalytics(app), "select_content");
export { log };
